import { render, staticRenderFns } from "./big_package.vue?vue&type=template&id=7d036c3a&scoped=true&"
import script from "./big_package.vue?vue&type=script&lang=js&"
export * from "./big_package.vue?vue&type=script&lang=js&"
import style0 from "./big_package.vue?vue&type=style&index=0&id=7d036c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d036c3a",
  null
  
)

export default component.exports